import fetchService from "./service";
import {setQuestionParams} from "./localStorageUtils";

export default function (question?: string) {
  if(null == question){
    window.open('https://vip.xiniudata.com/chat/stream')
    return;
  }

  let paramJSON = {"question": question}
  setQuestionParams('localQuestion', JSON.stringify(paramJSON))

  window.open('https://vip.xiniudata.com/chat/stream?q=' + question)
}

